module.exports = __webpack_public_path__ + "img/demo-remote-2.de8ef013.png";